import React from 'react';
import EmptyState from './EmptyState';

/**
 * Pre-configured EmptyState variants for common scenarios
 */

export const NoResultsState = ({ onClearFilters, ...props }) => (
  <EmptyState
    variant="noResults"
    action={onClearFilters ? {
      label: 'Limpiar filtros',
      onClick: onClearFilters,
    } : undefined}
    {...props}
  />
);

export const NoAppointmentsState = ({ onFindTherapists, ...props }) => (
  <EmptyState
    variant="noAppointments"
    action={onFindTherapists ? {
      label: 'Buscar terapeutas',
      onClick: onFindTherapists,
    } : undefined}
    {...props}
  />
);

export const NoMessagesState = ({ onStartConversation, ...props }) => (
  <EmptyState
    variant="noMessages"
    action={onStartConversation ? {
      label: 'Iniciar conversación',
      onClick: onStartConversation,
    } : undefined}
    {...props}
  />
);

export const NoNotificationsState = (props) => (
  <EmptyState
    variant="noNotifications"
    {...props}
  />
);

export const ErrorState = ({ onRetry, ...props }) => (
  <EmptyState
    variant="error"
    action={onRetry ? {
      label: 'Reintentar',
      onClick: onRetry,
    } : undefined}
    {...props}
  />
);

export const NoPermissionState = ({ onGoHome, ...props }) => (
  <EmptyState
    variant="noPermission"
    action={onGoHome ? {
      label: 'Volver al inicio',
      onClick: onGoHome,
      variant: 'outlined',
    } : undefined}
    {...props}
  />
);

export const FirstTimeState = ({ onExplore, ...props }) => (
  <EmptyState
    variant="firstTime"
    size="large"
    action={onExplore ? {
      label: 'Explorar terapeutas',
      onClick: onExplore,
    } : undefined}
    {...props}
  />
);
